<template>
  <SACModal
    modalClass="shipping-address-modal"
    :cardClass="`sa-${view}`"
    :show="show"
    :close="() => toggle(false)"
  >
    <template
      v-if="view === 'edit-address'"
      #content
    >
      <EditAddressPopup
        :type="type"
        :address="address"
        :states="states"
        :countries="countries"
        :update="update"
        :toggle="toggle"
        />
      </template>
      <template
      v-else-if="view === 'delete-address'"
      #content
      >
      <DeleteShippingAddressPopup
        :update="update"
        :address="address"
        :toggle="toggle"
      />
    </template>
  </SACModal>
</template>

<script>
import { mapState } from 'vuex';
import SACModal from '@shared/components/sac/SACModal.vue';
import EditAddressPopup from './EditAddressPopup.vue';
import DeleteShippingAddressPopup from './DeleteShippingAddressPopup.vue';

export default {
  name: 'AddressModal',
  components: {
    SACModal,
    EditAddressPopup,
    DeleteShippingAddressPopup,
  },
  props: {
    show: Boolean,
    type: String,
    view: String,
    toggle: Function,
    states: Array,
    address: Object,
    update: Function,
  },
  computed: {
    ...mapState({
      countries: (state) => state.general.countries,
    }),
  },
};
</script>

<style lang="scss">
.shipping-address-modal {
  .sa-edit-address {
    width: 650px;
    height: 600px;
    .ac-body-container {
      overflow-y: auto;
    }
  }

  .sa-delete-address {
    width:600px;
    height: 270px;
  }

  .ac-input-container {
    margin-right: 0;
  }

  .ac-card-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    animation: fadeIn 0.5s ease;
    position: relative;

    .ac-header-container {
      padding: 29px 24px 19px 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .ac-header {
        font-size: 20px;
        font-weight: 500;
      }

      .ac-close-button {
        width: 32px;
        height: 32px;
        border-radius: 6px;
        background-color: $NBLUE10;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
          background-color: $NBLUE20;
        }

        .ac-close {
          width: 10px;
          height: 10px;
        }
      }
    }

    .ac-body-container {
      flex: 1;
      padding: 31px 24px 26px 24px;

      .upload-image-container {
        background: $N10;
        display: grid;
        align-items: center;
        justify-content: center;
        border-radius: 6px;
        height: 100%;
        width: 500px;
        height: 300px;

        .dropbox-form {
          height: 100%;

          .dropbox-container {
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 5px;
            cursor: pointer;
            position: relative;

            .db-input {
              opacity: 0;
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              width: 100%;
              cursor: pointer;
            }

            .db-header {
              display: flex;
              flex-direction: column;
              font-size: 1.25rem;
              font-weight: 500;
              text-align: center;
            }
          }
        }

        .image-preview {
          width: 100%;
          object-fit: contain;
          overflow: hidden;
        }
      }

      .ac-body-header {
        font-size: 1.25rem;
        font-weight: 500;
        text-align: center;
        margin-bottom: 25px;
      }

      .ac-body-sub-container {
        display: grid;
        grid-auto-flow: column;
        gap: 2rem;
      }

      .ac-input-container {
        &:not(:last-child) {
          margin-bottom: 18px;
        }

        .ac-input-header {
          font-size: 0.875rem;
          font-weight: 500;
          margin-bottom: 5px;

          .ac-input-sub {
            font-size: 0.75rem;
            color: $N50;
          }

          .required {
            color: $TOMATO100;
          }
        }

        input {
          height: 48px;
          width: 100%;
          background-color: $NBLUE5;
          border: none;
          border-radius: 2px;
          padding: 0 10px;
        }

        input[type=checkbox] {
          width: auto;
          height: auto;
          margin-right: 6px;
        }

        textarea {
          width: 100%;
          height: 143px;
          padding: 8px 10px;
          border-radius: 2px;
          background-color: $NBLUE5;
          border: none;
          resize: none;
        }

        .ac-input-footer-container {
          display: flex;

          .ac-text-count {
            flex: 1;
            text-align: right;
            font-size: 0.75rem;
            font-weight: 500;
            color: $N60;
          }
        }

        .ac-input-error {
          color: $TOMATO100;
          font-size: 0.875rem;
        }
      }

      .ac-status {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        background: $NBLUE5;
        padding: 20px;
        border-radius: 6px;
        font-size: 16px;
        margin-bottom: 8px;
        font-weight: 500;
      }

      .ac-note-container {
        margin-bottom: 32px;

        .ac-note {
          font-weight: 500;
          color: $N60;
        }

        .ac-info {
          font-weight: 500;
        }
      }
    }
  }

  .ac-card-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    animation: fadeIn 0.5s ease;
    position: relative;

    .ac-header-container {
      padding: 29px 24px 19px 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid $NBLUE10;

      .ac-header {
        font-size: 1.25rem;
        font-weight: 500;
      }

      .ac-close-button {
        width: 32px;
        height: 32px;
        border-radius: 6px;
        background-color: $NBLUE10;
        display: flex;
        align-items: center;
        justify-content: center;

        &:hover {
          background-color: $NBLUE20;
        }

        .ac-close {
          width: 10px;
          height: 10px;
        }
      }
    }

    .ac-body-container {
      flex: 1;
      padding: 31px 24px 26px 24px;

      .upload-image-container {
        background: $N10;
        display: grid;
        align-items: center;
        justify-content: center;
        border-radius: 6px;
        height: 100%;
        width: 500px;
        height: 300px;

        .dropbox-form {
          height: 100%;

          .dropbox-container {
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 5px;
            cursor: pointer;
            position: relative;

            .db-input {
              opacity: 0;
              position: absolute;
              top: 0;
              left: 0;
              right: 0;
              bottom: 0;
              width: 100%;
              cursor: pointer;
            }

            .db-header {
              display: flex;
              flex-direction: column;
              font-size: 1.25rem;
              font-weight: 500;
              text-align: center;
            }
          }
        }

        .image-preview {
          width: 100%;
          object-fit: contain;
          overflow: hidden;
        }
      }

      .ac-body-header {
        font-size: 1.25rem;
        font-weight: 500;
        text-align: center;
        margin-bottom: 25px;
      }

      .ac-body-sub-container {
        display: grid;
        grid-auto-flow: column;
        gap: 2rem;
      }

      .ac-input-container {
        &:not(:last-child) {
          margin-bottom: 18px;
        }

        .ac-input-header {
          font-size: 0.875rem;
          font-weight: 500;
          margin-bottom: 5px;

          .ac-input-sub {
            font-size: 0.75rem;
            color: $N50;
          }

          .required {
            color: $TOMATO100;
          }
        }

        input {
          height: 48px;
          width: 100%;
          background-color: $NBLUE5;
          border: none;
          border-radius: 2px;
          padding: 0 10px;
        }

        input[type=checkbox] {
          width: auto;
          height: auto;
          margin-right: 6px;
        }

        textarea {
          width: 100%;
          height: 143px;
          padding: 8px 10px;
          border-radius: 2px;
          background-color: $NBLUE5;
          border: none;
          resize: none;
        }

        .ac-input-footer-container {
          display: flex;

          .ac-text-count {
            flex: 1;
            text-align: right;
            font-size: 0.75rem;
            font-weight: 500;
            color: $N60;
          }
        }

        .ac-input-error {
          color: $TOMATO100;
          font-size: 0.875rem;
        }
      }

      .ac-status {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        background: $NBLUE5;
        padding: 20px;
        border-radius: 6px;
        font-size: 16px;
        margin-bottom: 8px;
        font-weight: 500;
      }

      .ac-note-container {
        margin-bottom: 32px;

        .ac-note {
          font-weight: 500;
          color: $N60;
        }

        .ac-info {
          font-weight: 500;
        }
      }
    }
  }

  .ac-tax-footer-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-bottom: 10px;

    .ac-back-container {
      flex: 1;
      justify-content: flex-start;
    }
  }

  .ac-footer-container {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 16px 24px;
    border-top: 1px solid $NBLUE10;

    .ac-back-container {
      flex: 1;
      justify-content: flex-start;

      .ac-back-button {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 17px;
        width: 177px;
        height: 40px;
        border-radius: 6px;
        background-color: $NBLUE10;

        &:hover {
          background-color: $NBLUE20;
        }

        .back-icon {
          width: 6px;
        }

        .button-text {
          font-weight: 600;
        }
      }
    }

    .ac-form-button {
      padding: 0 16px;
      height: 40px;
      border-radius: 6px;
      background-color: $NBLUE100;
      color: $WHITE;
      font-weight: 600;

      &:hover {
        background-color: $NBLUE90;
      }

      &:not(:last-child) {
        margin-right: 11px;
        background-color: $N40;

        &:hover {
          background-color: $NBLUE20;
        }
      }
    }
  }

  .ac-overlay {
    border-radius: 12px;
  }
}
</style>
